import gql from 'graphql-tag'
import moment from 'moment'
import * as React from 'react'
import { Mutation } from 'react-apollo'
import styled, { css } from 'styled-components'
import Spin from 'web-makeup/dist/Spin'

import { CloudinaryImage, GetComments, RequestTicketState } from '../../typings/types'
import ChatBubble from '../ChatBubble'

const CommentsContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  align-items: center;
  width: 100%;
`

const ChatBubbles = styled.div`
  display: grid;
  grid-gap: 1.5rem;
  grid-auto-rows: min-content;
  padding: 3rem 1.5rem;
  height: 1rem;
  overflow-y: auto;
  flex: 1;
  width: 100%;
`

const Comment = styled(ChatBubble)<{ byMe?: boolean }>`
  @media all and (min-width: 64rem) {
    ${({ byMe }) =>
      css`
        ${byMe ? 'margin-left: 40%;' : 'margin-right: 40%;'};
      `};
  }
`

const PlaceholderContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
`

export const PlaceholderImage = styled.img`
  margin: 2rem;
`

const StyledSpin = styled(Spin as any)`
  && {
    align-self: start;
    margin: 2rem auto auto;
  }
`

interface Props {
  comments: GetComments.Comments[]
  requestUuid: string
  assigneeAvatar?: CloudinaryImage | null
  requestState: RequestTicketState
  notifications?: number | null
  assigneeUuid?: string | null
  loading: boolean
}

const MARK_NOTIFICATIONS_READ = gql`
  mutation markRead($uuid: ID!) {
    markRequestTicketNotificationsRead(uuid: $uuid) {
      uuid
    }
  }
`

const RequestCommentsContainer: React.SFC<Props> = ({
  requestUuid,
  comments,
  notifications,
  assigneeUuid,
  loading,
}) => (
  <Mutation mutation={MARK_NOTIFICATIONS_READ}>
    {(markRead, { called }) => {
      if (notifications && !called) {
        markRead({
          variables: { uuid: requestUuid },
          refetchQueries: ['getRequestDetails'],
        })
      }

      const sortedByDateComments =
        comments &&
        comments.filter(Boolean).sort((commentA, commentB) => {
          return moment(commentA.createdAt).unix() - moment(commentB.createdAt).unix()
        })

      return loading ? (
        <StyledSpin spinning />
      ) : (
        <CommentsContainer>
          {sortedByDateComments.length === 0 && (
            <PlaceholderContainer>
              <PlaceholderImage src="https://res.cloudinary.com/ninety-seconds/image/upload/v1521702422/misc/no-comment.png" />
            </PlaceholderContainer>
          )}
          <ChatBubbles>
            {sortedByDateComments.map(comment => {
              const { commenter, uuid, type, body, createdAt } = comment
              return (
                <Comment
                  byMe={assigneeUuid === commenter.uuid}
                  key={uuid}
                  uuid={uuid}
                  avatar={
                    commenter.avatar &&
                    commenter.avatar.cloudinaryId &&
                    commenter.avatar.cloudinaryType
                      ? {
                          id: commenter.avatar.cloudinaryId,
                          type: commenter.avatar.cloudinaryType,
                        }
                      : { id: 'placeholders/icon-user', type: 'upload' }
                  }
                  name={commenter.name}
                  type={type}
                  message={body}
                  createdAt={createdAt}
                />
              )
            })}
          </ChatBubbles>
        </CommentsContainer>
      )
    }}
  </Mutation>
)

export default RequestCommentsContainer



// WEBPACK FOOTER //
// ./src/components/RequestCommentsContainer/RequestCommentsContainer.tsx